import examplePassportPicture from "../../assets/images/passport_example.jpeg";
import correctPersonPicture from "../../assets/images/correct_passport_pic.jpeg";
import wrongPersonPicture from "../../assets/images/wrong_passport_pic.jpeg";

const photoMsg =
  "בכדי להמנע מעיכובים, נא הקפידו להצטלם לפי הדוגמאות הנ״ל:\nתמונה-רקע קיר לבן, שיער אסוף, מצח גלוי, פנים ישרות, להסתכל למצלמה";
const passportPhotoMsg =
  "בכדי להמנע מעיכובים, נא הקפידו להצטלם לפי הדוגמאות הנ״ל:\nצילום מלא, ללא פלאשים";

export const photoPopUpHtml = (name) => {
  return `
<div class="d-flex width100 ${
    name === "pictureOfPassport" ? "justify-center" : "justify-between"
  }
  ${name === "pictureOfPerson" && "group-form-columns-on-mobile"}
  ">
  <div class=${name === "pictureOfPassport" ? "group-form-picture-of-passport" : "group-form-wrong-image"}>
    <img src=${
      name === "pictureOfPassport" ? examplePassportPicture : wrongPersonPicture
    } alt="example picture" class=${name === "pictureOfPerson" ? "group-form-wrong-image-filter" : ""} />
  </div>
  ${
    name !== "pictureOfPassport"
      ? `<img src=${correctPersonPicture} alt="example person" class="group-form-picture-of-person" />`
      : ""
  }
</div>
<div class="mt-20">${
    name === "pictureOfPassport" ? passportPhotoMsg : photoMsg
  }</div>
`;
};

export const maritalStatus = [
  { label: "רווק/ה", value: "single" },
  { label: "נשוי/נשואה", value: "married" },
  { label: "גרוש/ה", value: "divorced" },
  { label: "אלמן/ה", value: "widowed" },
];
